import React, { useContext, useEffect, useRef, useState } from "react";
import classes from "./EditServices.module.scss";
import { Collapse, Container, OverlayTrigger, Row, Tooltip,Col } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { DDD, E2Data } from "../lib/ddd/ddd";
import { OrgIdContext } from "../store/orgId_context";
import Button from "../components/UI/Button";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { ReactComponent as DownloadIcon } from "../assets/external-link-svgrepo-com.svg";
import SendMailRequest from "../components/navbar/SendMailRequest";
import { NotificationManager} from 'react-notifications';
import Alert from '@mui/material/Alert';
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import useInterval from "../lib/useInterval";

const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";

const e2Data = new E2Data("EU_ISVPlugins");
e2Data.format="Full";
e2Data.filter = "Valid = true";


const PreMadePlugin = () => {
    const { integrationDevice, aboutOrgId, sessionInfo, ISVCustomer,setSessionInfoHandler} = useContext(OrgIdContext);
    const [sendMailPopup, setSendMailPopup] = useState(false);
    const [providers, setProviders] = useState([]);
    const {t} = useTranslation();
    const abortLoop = useRef(false);

    const {isPending : isDataPending, data} = useQuery({
        queryKey: ['Data.GetEntityData', e2Data.GetParamsObject()],
        queryFn: () => e2Data.GetData(),
    })

    useInterval(() => {
        reloadProviders();
    }, 10000);

    useEffect(() => {reloadProviders();}, []);

    const reloadProviders = () => {
        if(abortLoop.current) return;
        const ddd = new DDD(apiRequestAddress);
        ddd.Rpc_ExecuteExtension("EUeInvoices.GetMyProviders", {}).then(res => {
            if(res?.error) abortLoop.current = true;
            if(res?.result?.data && res.result.data.length > 0){
                if(providers.length === 0) refetchSessionData();
                setProviders(res.result.data);
            }
        });
    }

    const onNewCompanyCreated = (data) => {};
    const refetchSessionData = () => {
        const ddd = new DDD(apiRequestAddress);
        ddd.InvalidateSessionExtensions().then(() => {
            ddd.GetSessionAuthDescribe({includeExtendedInfo: true}).then(res => {
                if(res?.result)
                    setSessionInfoHandler(res.result);
            });
        });
    }

    const onSubscribed = () => {
        reloadProviders();
    }

    return (
    <>
      <Helmet>
        <title>Pre-made plugin | DDD Invoices</title>
      </Helmet>
      <div className={`h-100 w-100 p-5 ${classes.container}`}>
        <Row>
            <Col className="col-12 col-md-6">
                <div>
                    <div className={classes.smollTitle}>{t("Activate the plugins to push & sync your data into DDD Invoices")}</div>
                    <div className="mt-2 mb-2">{t("By activating the plugin, your invoice data will be automatically pushed into DDD Invoices from each of the softwares and delivered via delivery channels to the right destination.")}</div>
                </div>
            </Col>
            <Col className="text-end col-12 col-md-6"><Button style={{padding:"2px 1em"}} onClick={() => setSendMailPopup(true)}>{t("Request a plugin")}</Button></Col>
        </Row>
        {/* {sessionInfo?.Extended?.ISVCustomer && <Alert className="mt-1 mb-2" severity="warning">This company is already a client of an existing ISV and can not be added to another.</Alert>} */}
        <div className="d-flex flex-wrap" style={data?.result?.data?.length < 10 ? {maxWidth:"650px"}:{}}>
            {data?.result?.data?.map((plugin) => {
                return <CompanyPlugin key={plugin?.Id} data={plugin} subscribed={providers?.length > 0} providers={providers} onSubscribed={onSubscribed}/>
            })}
        </div>
        <SendMailRequest show={sendMailPopup} onHide={() => setSendMailPopup(false)} onAddNewCompany={onNewCompanyCreated}/>
      </div>
    </>
    );
};

const CompanyPlugin = ({data, subscribed, providers, onSubscribed, ...props}) =>{
    const [activating, setActivating] = useState(false);
    const {ISVCustomer,sessionInfo, setSessionInfoHandler,connectionKey} = useContext(OrgIdContext);
    const [confirmDialog, setConfirmDialog] = useState();
    const {t} = useTranslation();

    const openInstructionLink = () => {
        if (data?.InstructionsURL)
            window.open(data?.InstructionsURL, '_blank', 'noopener,noreferrer');
    };
    const activateISVParent = () => {
        if(activating) return;
        setActivating(true);
        setConfirmDialog(false);
        const ddd = new DDD(apiRequestAddress);
        ddd.Rpc_ExecuteExtension("EUeInvoices.ActivatePluginISV", {Id: data?.Id, ConnectionKey: connectionKey}).then((res) => {
            setActivating(false);
            if(res?.result?.Status==="OK"){
                ddd.InvalidateSessionExtensions().then(() => {
                    ddd.GetSessionAuthDescribe({includeExtendedInfo: true}).then(res => {
                        if(res?.result)
                          setSessionInfoHandler(res.result);
                    });
                });
                NotificationManager.success(t("The plugin has been activated successfully"), t("Success"));
                if(onSubscribed) onSubscribed();
            }else{
                NotificationManager.error(res?.result?.Reason || t("An error occurred while activating the plugin"), t("Error"));
            }
        });
    };

    const activateISVParent2 = () => {
        if(activating) return;
        setActivating(true);
        setConfirmDialog(false);
        const ddd = new DDD(apiRequestAddress);
        ddd.Rpc_ExecuteExtension("EUeInvoices.MoveUnderISV", {Id: data?.Id, CustomerType : "Company"}).then((res) => {
            setActivating(false);
            if(res?.result?.Status==="OK"){
                ddd.InvalidateSessionExtensions().then(() => {
                    ddd.GetSessionAuthDescribe({includeExtendedInfo: true}).then(res => {
                        if(res?.result)
                          setSessionInfoHandler(res.result);
                    });
                });
                NotificationManager.success(t("The plugin has been activated successfully"), t("Success"));
                
            }else{
                NotificationManager.error(res?.result?.Reason || t("An error occurred while activating the plugin"), t("Error"));
            }
        });
    };

   const copyAPIKey = () =>{
        navigator.clipboard.writeText(connectionKey);
        NotificationManager.success(``, t("Copied!"));
    }

    const isNotThis =  data.Active && subscribed && !providers.some(prov => prov?.TransformerId === data?.Organization);
    const isThis =  data.Active && subscribed && providers.some(prov => prov?.TransformerId === data?.Organization);

    return(<>
        <Dialog
        sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: 435 } }}
        maxWidth="xs"
        TransitionProps={{ }}
        open={confirmDialog}>
            <DialogTitle>{t("Confirm plugin")}</DialogTitle>
            <DialogContent dividers>
            {t("Are you certain you wish to activate this plugin?")}
            </DialogContent>
            <DialogActions>
                <Button className="ps-2 pe-2" autoFocus onClick={() => setConfirmDialog(false)}>
                {t("Cancel")}
                </Button>
                <Button className="ps-2 pe-2" onClick={activateISVParent}>Ok</Button>
            </DialogActions>
        </Dialog>
        <div className={`${classes["company-plugin"]} m-1`} style={isThis ? {border: "3px solid green"} : {}} {...props}>
            <div className="p-3" >
                <span className={classes["company-plugin-title"]} onClick={openInstructionLink} style={{fontWeight:"700"}}>{data?.Name}</span>
                {data?.InstructionsURL && <OverlayTrigger overlay={<Tooltip>{t("How to guide")}</Tooltip>}>
                    <DownloadIcon className={classes["hyperlinkSvg"]} onClick={openInstructionLink}/>
                </OverlayTrigger> }
            </div>
            <div className="d-flex mt-auto p-3">
                <img style={{height:"25px", paddingLeft:"2px", maxWidth:"160px"}} src={process.env.REACT_APP_ORIGIN ?  process.env.REACT_APP_ORIGIN+'/'+data?.Logo : '/'+data?.Logo}></img>
                <div className="ms-auto mt-1">
                    {/* {data?.Active && <Button style={{padding:"2px 1em"}} onClick={() => setConfirmDialog(true)} disabled={sessionInfo?.Extended?.ISVCustomer||activating}>{t("Activate")}</Button>} */}
                    {!data?.Active && <Button style={{padding:"2px 1em", fontSize:"0.7rem"}} disabled>{t("Coming soon")}</Button>}
                    {data?.Active && <>
                        {isThis && <span className={`${classes["status-badge"]} ${classes["status-badge--active"]}`}>{t("Active")}</span>}
                        {isNotThis && 
                            <OverlayTrigger overlay={<Tooltip>{t("This company  has already connected another plugin")}</Tooltip>}>
                                <Button style={{padding:"2px 1em"}} disabled={true} onClick={copyAPIKey} >{t("Activate")}</Button>
                            </OverlayTrigger>
                        }
                        {!subscribed && data.Type ==="CopyAPIKey" && <><Button style={{padding:"2px 1em", fontSize:"0.7rem"}} onClick={copyAPIKey} >{t("Copy API key")}</Button></>}
                        {!subscribed && data.Type ==="MoveUnderISV" && <><Button style={{padding:"2px 1em", fontSize:"0.7rem"}} onClick={() => setConfirmDialog(true)} disabled={activating}>{t("Activate")}</Button></>}
                        {!subscribed && data.Type ==="NoAction" && <><Button style={{padding:"2px 1em", fontSize:"0.7rem"}} onClick={openInstructionLink}>{t("Connect from plugin side")}</Button></>}
                    </>}
                </div>
            </div>
        </div>
    </>)
};

export default PreMadePlugin;
